import Player from "./player";
/**
 * Handle behaviors
 */
const Guide = {
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for document ready
		document.addEventListener('DOMContentLoaded', Guide._ready);
		// listen for window resize/load
		window.addEventListener('resize', Guide.Slider._resizeHandler);
		window.addEventListener('load', Guide.Slider._resizeHandler);
		window.addEventListener('scroll', Guide.Slider._scrollHandler);
	},
	/**
	 * Handle document ready
	 */
	_ready: () => {
		// init the slider
		Guide.Slider._init();
	},
	/**
	 * Handle slider behavior
	 */
	Slider: {
		// holder for current slide index
		currentSlideIndex: 0,
		// all the slides
		slides: null,
		/**
		 * Entry point
		 */
		_init: () => {
			// get slides
			if (Guide.Slider.slides === null) {
				Guide.Slider.slides = document.querySelectorAll('.guide-slides-slide');
			}

			// if there's slides
			if (Guide.Slider.slides.length > 0) {
				let slideNumber = 0;
				// is there a hash?
				if (window.location.hash.length > 0) {
					// get slide number by hash
					slideNumber = Guide.Slider._getSlideNumberByHash();
					// default to 0 if not found for whatever reason
					slideNumber = -1 === slideNumber ? 0 : slideNumber;
				}

				// go to the slide
				Guide.Slider._goToSlide(slideNumber);
				// set the activeAudioIndex to be the active slide's
				Player.activeAudioIndex = slideNumber;
			}

			// listen for header title clicks
			const headerTitles = document.querySelectorAll('.guide-slides-slide-header-title');
			if (headerTitles.length > 0) {
				headerTitles.forEach((headerTitle) => {
					headerTitle.addEventListener('click', Guide.Slider._headerTitleClickHandler);
				});
			}

			// listen for list item link clicks
			const listItems = document.querySelectorAll('.guide-list-wrapper-item-link');
			if (listItems.length > 0) {
				listItems.forEach((listItem) => {
					listItem.addEventListener('click', Guide.Slider._listItemClickHandler);
				});
			}

			// listen for player events
			const playPauses = document.querySelectorAll('.guide-slides-slide-header-player-playpause');
			if (playPauses.length > 0) {
				playPauses.forEach(playPause => {
					playPause.addEventListener('click', Guide.Slider._playPauseClickHandler);
				});
			}

			const seeks = document.querySelectorAll('.guide-slides-slide-header-player-progress');
			if (seeks.length > 0) {
				seeks.forEach(seek => {
					seek.addEventListener('click', Guide.Slider._seekClickHandler);
				});
			}

			document.addEventListener('pammbt:guide:player:loadeddata', Guide.Slider._playerLoadedDataHandler);
			document.addEventListener('pammbt:guide:player:timeupdate', Guide.Slider._playerTimeUpdateHandler);
			document.addEventListener('pammbt:guide:player:ended', Guide.Slider._playerEndedHandler);

			// listen for slide pagination clicks
			const paginationLinks = document.querySelectorAll('.guide-slides-slide-pagination-item-link');
			if (paginationLinks.length > 0) {
				paginationLinks.forEach(paginationLink => paginationLink.addEventListener('click', Guide.Slider._paginationLinkClickHandler));
			}
		},
		/**
		 * Adjust element positioning etc. for desktop
		 */
		_resizeHandler: () => {
			const slide = document.querySelector('.guide-slides-slide.active');
			Guide.Slider._addSlideMarginBottom(slide);
		},
		/**
		 * Add the margin bottom of the bottom of the slide content on desktop so the list that's to the left of it has enough vertical real estate to not overlap other elements because it's absolute positioned.
		 * @param {HTMLElement} slide 
		 */
		_addSlideMarginBottom: (slide) => {
			const slideContent = slide.querySelector('.guide-slides-slide-content');
			if (window.innerWidth > 1200) {
				const list = document.querySelector('.guide-list-wrapper');
				const listBB = list.getBoundingClientRect();
				const slideContentBB = slideContent.getBoundingClientRect();
				
				if (listBB.bottom > slideContentBB.bottom) {
					slideContent.style.marginBottom = `${listBB.bottom - slideContentBB.bottom + 200}px`;
				}
			}
			else {
				slideContent.style.marginBottom = '0px';
			}
		},
		/**
		 * Get the slide number by the hash in the URL.
		 * @returns int the slide number. zero indexed. -1 if nothing found.
		 */
		_getSlideNumberByHash: (_hash = '') => {
			const hash = _hash === '' ? window.location.hash : _hash;
			return [...Guide.Slider.slides].map(slide => slide.dataset.id).indexOf(hash.replace('#', ''));
		},
		/**
		 * Goes to a slide by number. zero indexed.
		 * @param {int} slideNum the slide number to go to. 0 indexed.
		 * @param {callable} finished the cb to run when finished
		 */
		_goToSlide: (slideNum = 0, finished = () => {}) => {
			document.querySelectorAll('.guide-list-wrapper-item-link').forEach((link) => {{
				link.classList.remove('active');
			}});
			document.querySelectorAll('.guide-slides-slide-content-titleheader').forEach((titleHeader) => {{

				titleHeader.classList.remove('hidden');
			}
			})
			// loop throgh slides
			Guide.Slider.slides.forEach((slide, index) => {
				// set the corresponding slide with the active class
				if (index === slideNum) {
					// set the slide with active class
					slide.classList.add('active');

					document.querySelector(`.guide-list-wrapper-item-link[data-id=${slide.dataset.id}]`).classList.add('active');

					Guide.Slider._resizeHandler();
					// update hash in history
					history.pushState(null, null, `#${slide.dataset.id}`);
					// scroll to top
					window.scrollTo({
						top: 0,
						left: 0,
						behavior: 'smooth'
					});

				}
				else {
					slide.classList.remove('active');
				}
			});

			// set the current slide index
			Guide.Slider.currentSlideIndex = slideNum;
			// pause the audio
			Player._pauseAudio();
			// set the activeAudioIndex to be the active slide's
			Player.activeAudioIndex = slideNum;

			// finished
			finished();
		},
		/**
		 * Handle pagination link click
		 * @param {object} e the event object
		 */
		_paginationLinkClickHandler: (e) => {
			// prevent # in url
			e.preventDefault();

			// pause previous audio if it's playing
			if (Player._isPlaying()) {
				Player._pauseAudio();
			}

			// update the desktop list/slide sizing
			const updateDesktopListSlideSizing = function(){
				Guide.Slider._addSlideMarginBottom( document.querySelector('.guide-slides-slide.active') );
			};

			// go to slide either +1 or -1 based on which button was clicked.
			if (e.target.classList.contains('prev')) {
				Guide.Slider._goToSlide(Guide.Slider.currentSlideIndex - 1, updateDesktopListSlideSizing);
			}
			else if (e.target.classList.contains('next')) {
				Guide.Slider._goToSlide(Guide.Slider.currentSlideIndex + 1, updateDesktopListSlideSizing);
			}

		},
		/**
		 * Handle audio data loaded
		 * @param {object} e the event object
		 */
		_playerLoadedDataHandler: (e) => {
			// update the times total text content with the audio duration in a format
			const { index, audio } = e.detail;
			const total = document.querySelector(`.guide-slides-slide:nth-child(${index + 1}) .guide-slides-slide-header-player-times-total`);
			if (null !== total) {
				total.textContent = Guide.Slider._secondsToMS(audio.duration);
			}
			else {
				console.log(`Error processing playerloaded data.`, e);
			}
		},
		/**
		 * Handle playpause click
		 * @param {object} e the event object
		 */
		_playPauseClickHandler: (e) => {
			e.preventDefault();

			if (Player._isPlaying()) {
				e.target.querySelector('.guide-slides-slide-header-player-playpause-play').classList.add('active');
				e.target.querySelector('.guide-slides-slide-header-player-playpause-pause').classList.remove('active');
				Player._pauseAudio();
			}
			else {
				e.target.querySelector('.guide-slides-slide-header-player-playpause-play').classList.remove('active');
				e.target.querySelector('.guide-slides-slide-header-player-playpause-pause').classList.add('active');
				Player._playAudio(Guide.Slider.currentSlideIndex);
			}
		},
		/**
		 * Handle player time update
		 * @param {object} e the event object
		 */
		_playerTimeUpdateHandler: (e) => {
			// update the current time in the header
			document.querySelector(`.guide-slides-slide:nth-child(${e.detail.index + 1}) .guide-slides-slide-header-player-times-current`).textContent = Guide.Slider._secondsToMS(e.detail.audio.currentTime);

			// update the seek
			document.querySelector(`.guide-slides-slide:nth-child(${e.detail.index + 1}) .guide-slides-slide-header-player-progress-bar`).style.width = `${100 * (e.detail.audio.currentTime / e.detail.audio.duration)}%`;
		},
		/**
		 * Handle player end
		 * @param {object} e the event object
		 */
		_playerEndedHandler: (e) => {
			document.querySelector('.guide-slides-slide-header-player-playpause-play').classList.add('active');
			document.querySelector('.guide-slides-slide-header-player-playpause-pause').classList.remove('active');
		},
		_headerTitleClickHandler: (e) => {
			// prevent # in url
			e.preventDefault();

			document.querySelector('.guide-list').classList.add('active')

			// Scroll to top of page on mobile
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'instant'
			});
		},
		_listItemClickHandler: (e) => {
			// close the list
			document.querySelector('.guide-list').classList.remove('active')
			const url = e.target.href;
			const hash = new URL(url).hash;
			Guide.Slider._goToSlide(Guide.Slider._getSlideNumberByHash(hash));
		},
		/**
		 * Handle pagination link click
		 * @param {object} e the event object
		 */
		_seekClickHandler: (e) => {
			const progressEl = e.target.closest('.guide-slides-slide-header-player-progress');

			const bbRect = progressEl.getBoundingClientRect();

			const s = Guide.Slider._map(e.clientX, bbRect.left, bbRect.width + bbRect.left, 0, Player._getDuration());

			Player._seekAudio(s);
		},
		_scrollHandler: (e) => {
			const guideTitleHeader = document.querySelector('.guide-slides-slide.active .guide-slides-slide-content-titleheader');
			const guidelistTitleHeader = document.querySelector('.guide-list-wrapper-titleheader');

			if (window.scrollY > 80) {
				console.log(guideTitleHeader);
				guideTitleHeader.classList.add('hidden');
				guidelistTitleHeader.classList.remove('hidden');
				guidelistTitleHeader.classList.add('visible');
			} else {
				guideTitleHeader.classList.remove('hidden');
				guidelistTitleHeader.classList.add('hidden');
				guidelistTitleHeader.classList.remove('visible');
			}
		},
		/**
		 * Utility method to handle displaying of time like m:ss
		 * @param {double} s time in seconds
		 */
		_secondsToMS: (s) => {
			const minutes = Math.floor(s / 60);
			const seconds = Math.floor(s % 60);
			return `${minutes}:${seconds.toString().padStart(2, '0')}`;
		},
		/**
		 * Maps a value (`v`) from one range (`e` to `g`) to another range (`a` to `n`).
		 * Returns a corresponding value in the new range, or `undefined` if conditions are not met.
		 * 
		 * @param {number} v - The value to map.
		 * @param {number} e - The start of the first range.
		 * @param {number} g - The end of the first range.
		 * @param {number} a - The start of the second range.
		 * @param {number} n - The end of the second range.
		 * @returns {number|undefined} The mapped value, or `undefined` if no valid mapping exists.
		 */
		_map: (v, e, g, a, n) => { return e > g ? e > v ? (v - e) * (n - a) / (g - e) + a : a : g > e ? g > v ? (v - e) * (n - a) / (g - e) + a : n : void 0; }
	},
};

export default Guide;